import React from 'react';
import styled from 'styled-components';
import { convert } from 'ethereumjs-units';
import Perk from './Perk';

const Title = styled.h2`
  letter-spacing: 0.2em;
  text-transform: uppercase;
  text-align: center;
  margin-top: 0;
`;

const Wrap = styled.div`
  text-align: left;
  padding: 30px;
`;

const PerksWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 700px;
  margin: 0 auto;

  @media (max-width: 550px) {
    display: block;
  }
`;

const Ul = styled.ul`
  padding-left: 1.2em;
`;

const PERKS = [
  {
    title: 'Unlimited access to existing music and video',
    emoji: '💿 📺',
    description:
      'Available for the authenticated user on this webpage starting Dec 26, 2018. Music formats: mp3 and flac. Video format: mp4',
    unlocksAt: 0
  },
  {
    title: 'Access to pre-releases',
    emoji: '🍾 🎫 🎀',
    description:
      'Music and video that is complete, but not released to the public, usually 1-2 months ahead',
    unlocksAt: 5
  },
  {
    title: 'Unlimited access to Mngwa shows',
    emoji: '🎫♾',
    description:
      'For the Genesis cat owner, present the proof of the cat ownership at the door',
    unlocksAt: 10
  },
  {
    title: 'Unlimited access to shows and music for all the direct offspring',
    emoji: '🐱🎫 🐱🎫 🐱🎫',
    description:
      'You can breed the Genesis’ children and sell/gift them to anyone.',
    unlocksAt: 50
  },
  {
    title: 'Mngwa Santa package for the current owner of the token',
    emoji: '🎅 🎁',
    description:
      "A collection of merch is sent between Dec 1 and Jan 30 every year. Only applicable if we have access to the owner's shipping address. Valid over the lifetime of the band",
    unlocksAt: 100
  },
  {
    title: 'Claim a personal concert',
    emoji: '🕺 🎸 🎻 🎺 🥁',
    description: (
      <div>
        Conditions:
        <Ul>
          <li>transportation/visa not included and must be covered</li>
          <li>
            Equipment, performance and the entertainment for the night are on us
          </li>
          <li>You get the profit, if there is any ;)</li>
        </Ul>
      </div>
    ),
    unlocksAt: 250
  },
  {
    title: 'We’ll write a song for you',
    emoji: '🎼 💸',
    description:
      'We grant you a commercial license to use it in any way you find appropriate',
    unlocksAt: 500
  },
  {
    title: 'Music video for your song',
    emoji: '📺',
    description: 'Same as previous + a music video for that song',
    unlocksAt: 1000
  },
  {
    title: 'North American tour (US, Canada, Mexico)',
    emoji: '🇺🇸🇨🇦🇲🇽 🕺',
    description:
      'including one additional concert in the city of your choice. Subject to sanity check',
    unlocksAt: 2000
  },
  {
    title: 'European (or South/Central American) tour',
    emoji: '🇫🇷🇩🇪🇪🇸🇧🇷🇦🇷🇨🇴 🕺',
    description:
      'including one more concert of your choice. Within reasonable limits',
    unlocksAt: 3000
  },
  {
    title: 'World tour',
    emoji: '🌎 🌍 🌏 🕺 🕺',
    description:
      'World tour and two more concerts of your choice. As long as they’re along the same bus route',
    unlocksAt: 5000
  }
];

export default function Perks({ offer }) {
  // const currentHighestOffer = offer.
  const price = offer && offer.eth_price ? offer.eth_price : '0';
  const currentHighestOfferWei = price;
  const currentHighestOfferEthNumber = parseFloat(
    convert(currentHighestOfferWei, 'wei', 'eth')
  );

  return (
    <Wrap>
      <Title>Perks</Title>
      <PerksWrap>
        {PERKS.map(perk => (
          <Perk
            {...perk}
            key={perk.title}
            active={perk.unlocksAt <= currentHighestOfferEthNumber}
          />
        ))}
      </PerksWrap>
    </Wrap>
  );
}
